import KunLoading26 from './src/index'

KunLoading26.install = function (Vue) {
	Vue.component(KunLoading26.name, KunLoading26);
}

export default KunLoading26;
